/**
 * AuthGate (web) — Layer 0/3 진입 라우팅 가드 (Issue #484 보강)
 *
 * app/src/components/AuthGate.tsx와 동일 패턴. web 차이:
 *   - `browserHistory` enabled (브라우저 history API 사용 — deep link / 뒤로가기)
 *   - 초기 url: 인증 `/`, 미인증 `/login`
 *
 * `<View>` 가 `AuthGate` 내부에 호스팅됨. App.tsx에서 `<Panel>`/`<PaywallHost>` 는
 * F7App 형제 슬롯에 유지.
 */

import { View } from 'framework7-react';
import { useAuth } from '@app/hooks/useAuth';

export function AuthGate() {
  const { isAuthenticated, isLoading, user } = useAuth();

  // #521 Phase B: AuthContext transient state (`{isAuthenticated:true, user:null, isLoading:false}`)
  // 가 한 tick 동안 노출될 경우 보호 라우트 자식이 user.id 참조로 throw. splash 로 마운트 차단.
  if (isLoading || (isAuthenticated && !user)) {
    return <div className="auth-gate-splash" data-testid="auth-gate-splash" aria-hidden="true" />;
  }

  const initialUrl = isAuthenticated ? '/' : '/login';

  return <View main url={initialUrl} browserHistory browserHistorySeparator="" />;
}
